export default __webpack_public_path__ + "static/bg-color-1-5088dd07ae5c547123e7d6d481875c96.jpg";